// 输出用户有权限的功能模块，前端根据key判断哪些功能可用
export enum PermissionKey {
  /** 资产库 */
  assets = 'assets',
  /** 定制模板 */
  dm = 'dm',
  /** 通用模板 */
  gm = 'gm',
  /** ps */
  ps = 'ps',
  /** 视频编辑器 */
  ve = 've',
  /** 视频批量制作 */
  veBatch = 've.batch',
  /** 录屏工具 */
  vrec = 'vrec',
  /** AI 服务 */
  ai = 'ai',
  /** AI视频 */
  aigc = 'aigc',
  /** 视频模版 */
  veTpl = 've.tpl',
  /** 创意洞察 */
  insights = 'insights',
}

// 广告主账号类型
export enum AdvertiserAccountType {
  /** 内部用户 */
  Internal = 1,
  /** 外部客户 */
  Normal = 2,
  /** ss 未同步数据时 */
  Default = 0,
}

export const AdvertiserAccountTypeLabel = {
  [AdvertiserAccountType.Default]: '外部客户',
  [AdvertiserAccountType.Normal]: '外部客户',
  [AdvertiserAccountType.Internal]: '内部用户',
}

export const mwsAccountTypeList = [
  {
    label: AdvertiserAccountTypeLabel[AdvertiserAccountType.Normal],
    value: AdvertiserAccountType.Normal,
  },
  {
    label: AdvertiserAccountTypeLabel[AdvertiserAccountType.Internal],
    value: AdvertiserAccountType.Internal,
  },
]

// 套餐类型
export enum GrantType {
  /** 全部 */
  All = 0,
  /** 正式 */
  Normal = 1,
  /** 试用 */
  Trial = 2,
  /** 内部 */
  Internal = 3,
}

export const GrantTypeLabel = {
  [GrantType.Normal]: '正式',
  [GrantType.Trial]: '试用',
  [GrantType.Internal]: '内部',
}

export const GrantTypeLabelOptions = [
  {
    label: GrantTypeLabel[GrantType.Normal],
    value: GrantType.Normal,
  },
  {
    label: GrantTypeLabel[GrantType.Trial],
    value: GrantType.Trial,
  },
  {
    label: GrantTypeLabel[GrantType.Internal],
    value: GrantType.Internal,
  },
]

// 套餐试用范围
export enum PlanScope {
  /** 可玩 */
  Playable = 1,
  /** 视频 */
  Video = 2,
  /** 可玩+视频 */
  Playable_Video = 3,
}

// 套餐id
export enum PlanNormal {
  /** 充值A餐 */
  planA = 21,
  /** 充值B餐 */
  planB = 22,
  topUpC = 35,
  topUpD = 36,
  /** 企业套餐 */
  planEnterprise = 29,
  /** 可玩CPM */
  planCPM = 26,
  /** 可玩REV */
  planREV = 31,
}

export const PlanScopeLabel = {
  [PlanScope.Playable]: '可玩',
  [PlanScope.Video]: '视频',
  [PlanScope.Playable_Video]: '可玩+视频',
}

export const statusOptions = {
  unactive: '未使用',
  active: '使用中',
  disable: '已停用',
  revoked: '已取消授权',
  expired: '已过期',
}

export const playStatusOptions = {
  1: '支付成功',
  2: '已退款',
  3: '部分退款',
}

export const currencyOptions = {
  1: 'USD',
  2: 'CNY',
}

export const taxForAdvOptions = {
  1: 'No Tax',
  2: 'Bid with tax & Billing without tax	',
  3: 'Bid without tax & Billing with tax	',
}

/** 套餐类型 */
export enum PlanType {
  /** 订阅套餐 */
  Subscription = 1,
  /** 额外购买 */
  Extra = 2,
  /** 按量套餐 */
  Ration = 3,
  /** 充值套餐 */
  Recharge = 4,
}

// 充值套餐类型
export enum RechargeType {
  // cpm套餐
  cpm = 'cpm',
  // rev套餐
  cost = 'cost',
}

// 业务类型
export enum BillingType {
  // 3D模型工单
  order = 'order',
  // 素材制作
  spend_share = 'spend_share',
  // 按渠道封顶（提前支付）
  cap = 'cap',
  // 全渠道封顶（提前支付）
  all_cap = 'all_cap',
  // 按渠道买断
  buyout = 'buyout',
  // 全渠道买断
  all_buyout = 'all_buyout',
}

// 账单流水-场景类型
export enum BillType {
  // cpm 和 cost 是 素材消耗
  // 按浏览数量扣费
  cpm = 'cpm',
  // 按成本比例扣费
  cost = 'cost',
  // 按渠道封顶（提前支付）
  cap = 'cap',
  // 全渠道封顶（提前支付）
  all_cap = 'all_cap',
  // 按渠道买断
  buyout = 'buyout',
  // 全渠道买断
  all_buyout = 'all_buyout',
}

export enum BillFlowType {
  spend = 'spend', // 素材消耗
  fixed = 'fixed', // 固定价格
}

export const templateTypeOptions = [
  {
    label: '系统模板',
    value: 'system',
  },
  {
    label: '个人模板',
    value: 'custom',
  },
]
